/**
 * @generated SignedSource<<19cb80b733a9c618da0cb0a0f6cb9550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamSettingsAdminSlackQuery$variables = {
  orgRelayId: string;
  teamId: string;
};
export type TeamSettingsAdminSlackQuery$data = {
  readonly orgRefetch: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamSettingsAdminSlack_org">;
  } | null;
};
export type TeamSettingsAdminSlackQuery = {
  variables: TeamSettingsAdminSlackQuery$variables;
  response: TeamSettingsAdminSlackQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgRelayId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSettingsAdminSlackQuery",
    "selections": [
      {
        "alias": "orgRefetch",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "FragmentSpread",
                "name": "TeamSettingsAdminSlack_org"
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamSettingsAdminSlackQuery",
    "selections": [
      {
        "alias": "orgRefetch",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "teamSettings",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manageTeamCalendar",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSlackSettings",
                        "kind": "LinkedField",
                        "name": "slackSettings",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notificationEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "channelId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "channelName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeSlot",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamSettings",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "slackAccountForTeamErrorable",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slackUserId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slackTeamId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "teamDisplayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "needsUpdate",
                        "storageKey": null
                      }
                    ],
                    "type": "SlackAccount",
                    "abstractKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cdffd4a7540b6a4241e8b5a4bd0ee432",
    "id": null,
    "metadata": {},
    "name": "TeamSettingsAdminSlackQuery",
    "operationKind": "query",
    "text": "query TeamSettingsAdminSlackQuery(\n  $orgRelayId: ID!\n  $teamId: String!\n) {\n  orgRefetch: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...TeamSettingsAdminSlack_org_1j7Wr3\n    }\n    id\n  }\n}\n\nfragment TeamSettingsAdminSlack_org_1j7Wr3 on Org {\n  id\n  experiments\n  teamSettings(teamId: $teamId) {\n    __typename\n    ... on TeamSettings {\n      manageTeamCalendar\n      slackSettings {\n        notificationEnabled\n        channelId\n        channelName\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  slackAccountForTeamErrorable(teamId: $teamId) {\n    __typename\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on SlackAccount {\n      slackUserId\n      slackTeamId\n      teamDisplayName\n      needsUpdate\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ac8d6e9d0107c4c777fac28dff9e867";

export default node;
